<script setup>
import {useAuthStore} from "@/stores/auth.js";
import { useRouter } from 'vue-router'

const userStore = useAuthStore();
const router = useRouter();

if (userStore.currentUser) {
  const startModuleRoute = userStore.currentUser.start_module?.route;
  if (startModuleRoute) {
    console.log('Start module route:', startModuleRoute);
    // Перенаправляем на маршрут из start_module.route
    router.push(`/${startModuleRoute}`);
  } else {
    // По умолчанию перенаправляем на главную страницу
    router.push({ name: 'Home' });
  }
}
</script>

<template>

</template>

<style scoped>

</style>
